import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';

import Navigation from './components/MainNavigation/Navigation';

import VideoPlaylist from './components/videoPlaylist/videoPlaylist';
import HighStageVideo from './components/AvHighStageVideo/highStageVideo';
import PartnerportalCockpit from './components/Partnerportal-Cockpit/Partnerportal-Cockpit';
import SdgContainer from './components/AvSdgConnect/SdgContainer';
import { SdgProjectOverviewData, SdgTileData } from './types';
import SdgTile from './components/AvSdgConnect/SdgTile';
import {getNavigationData, getTopicLineData} from './utils/utils';
import AvTopicLine from "./components/AvTopicLine/AvTopicLine";

const isDev = process.env.NODE_ENV === 'development';

// import basic vars, functions & utils
require('./index.scss');

/* eslint-disable global-require */
if (isDev) {
  // import basic styles (site-frame-styles)
  require('./__dev_only.scss');
}

// VideoPlaylist
const videoLists = document.querySelectorAll('[data-component-id="video-playlist"]');
videoLists.forEach((list) => {
  ReactDOM.render(
    <React.StrictMode>
      <VideoPlaylist jsonConfig={list.getAttribute('data-component-props') ?? ''} />
    </React.StrictMode>,
    list,
  );
});

// highStageVideo
const highStageVideo = document.querySelector('#highStageVideo');
if (highStageVideo) {
  ReactDOM.render(
    <React.StrictMode>
      <HighStageVideo jsonConfig={highStageVideo.getAttribute('data-component-props') ?? ''}/>
    </React.StrictMode>,
    highStageVideo,
  );
}



// Flyout Navigation
const navigation = document.querySelector('#main-navigation');
if (navigation) {
  const jsonConfig = getNavigationData(navigation, 'data-module-flyout-navigation');
  ReactDOM.render(
    <React.StrictMode>
      <Navigation
        config={jsonConfig}
        fixedSearch={navigation.innerHTML ?? ''}
      />
    </React.StrictMode>,
    navigation,
  );
}

// SDG Connect
const sdgConnect = document.getElementById('sdg-project-overview');
const sdgProjectOverviewConfig = document.getElementById('sdg-project-overview-config')?.innerHTML;
if (sdgConnect && sdgProjectOverviewConfig) {
  const config = JSON.parse(sdgProjectOverviewConfig);
    const {
      all_projects_link: allProjectsLink,
      button_prev_label: buttonPrevLabel,
      button_next_label: buttonNextLabel,
      background,
      display_type: displayType,
      headline,
      intro_text: introText,
      main_focus_text: mainFocusText,
      projects_list: sdgProjects,
    }: SdgProjectOverviewData = config;
    ReactDOM.render(
      <React.StrictMode>
        <SdgContainer
          {...{ allProjectsLink, buttonPrevLabel, buttonNextLabel, background, displayType, headline, introText, mainFocusText, sdgProjects }}
        />
      </React.StrictMode>,
      sdgConnect,
    );
}

// SDG Tile
const sdgTile = document.getElementById('sdg-tile');
const sdgTileConfig = document.getElementById('sdg-tile-config')?.innerHTML;
if (sdgTile && sdgTileConfig) {
  const config = JSON.parse(sdgTileConfig);
  const { region, budget, duration, sdgFocus, mainFocusText, sdgTileTitle, isDetailPage }: SdgTileData = config;
  ReactDOM.render(
    <React.StrictMode>
      <SdgTile {...{showTileTitle: true, region, budget, duration, sdgFocus, mainFocusText, sdgTileTitle, isDetailPage}} />
    </React.StrictMode>,
    sdgTile,
  );
}

// Partnerportal-Cockpit
const ppWrapper = document.querySelector('#partnerportal-cockpit');
if (ppWrapper) {
  ReactDOM.render(
    <React.StrictMode>
      <PartnerportalCockpit jsonConfig={ppWrapper?.getAttribute('data-component-props') ?? ''} />
    </React.StrictMode>,
    ppWrapper,
  );
}

// AV Topic Line Component
const topicLineList = document.querySelectorAll('[data-component-id="av-topic-line"]');
if (topicLineList.length > 0) {
  topicLineList.forEach((list) => {
    const jsonConfig = getTopicLineData(list, 'data-topic-line-props');
    ReactDOM.render(
      <React.StrictMode>
        <AvTopicLine config={jsonConfig}/>
      </React.StrictMode>,
      list,
    );
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export default {
  VERSION: '###VERSIONNUMBER###',
};
